import React, { useState } from 'react';
import firebase from 'firebase';
import { TextField } from '@mui/material';
import MainLayoutWrapper from '../../../components/wrappers/mainLayoutWrapper';
import Logo from "../../../assets/logoN3_transparent.png"
import { Container } from '@mui/system';
import { useHistory } from 'react-router-dom';

const PhoneLogin = () => {
	// Inputs
	const [mynumber, setnumber] = useState("");
	const [otp, setotp] = useState('');
	const [show, setshow] = useState(false);
	const [final, setfinal] = useState('');
    const auth = firebase.auth();
    const history = useHistory();

	// Sent OTP
	const signin = () => {

		if (mynumber === "" || mynumber.length < 10) return;

		let verify = new firebase.auth.RecaptchaVerifier('recaptcha-container');
		auth.signInWithPhoneNumber(mynumber, verify).then((result) => {
			setfinal(result);
			alert("code sent")
			setshow(true);
		})
			.catch((err) => {
				alert(err);
				window.location.reload()
			});
	}

	// Validate OTP
	const ValidateOtp = () => {
		if (otp === null || final === null)
			return;
		final.confirm(otp).then(async(result) => {
			// success
            const doc = await firebase.firestore().collection('users').where('phone','==',mynumber).get();
            if(doc.docs.length > 0){
                console.log("old user logged in");
                history.push('/'); 
            }else{
                console.log("new user signed up");
                const newDoc = await firebase.firestore().collection('users').doc();
                firebase.firestore().collection('users').doc(newDoc.id)
                .set({
                    email: '',
                    fullName: '',
                    uid: newDoc.id,
                    phone: mynumber,
                    birthDate:'',
                    emirate: '',
                    gender: '',
                    accessType: 'phone'

                }).then(()=>{
                    console.warn("user data saved successfully");
                    history.push('/'); 
                })
            }
		}).catch((err) => {
			alert("Wrong code");
		})
	}

	return (
        <Container>
        <MainLayoutWrapper>
              <img
          src={Logo}
          style={{ backgroundSize: "contain", width: 280, height: 280 }}
        />
		<div>
			<center>
				<div style={{ display: !show ? "block" : "none" }}>
					<input style={{width:"300px",height:"40px"}} value={mynumber} onChange={(e) => {
					setnumber(e.target.value) }}
						placeholder="Phone Number" />
					<br /><br />
					<div id="recaptcha-container"></div>
					<button style={{
                         border: 'none',
                        //  color: '';
                         padding:' 15px 32px',
                         textAlign: 'center',
                         textDecoration: 'none',
                         display: 'inlineBlock',
                         fontSize: '13px',
                         backgroundColor:"#fac904"
                    }} 
                     onClick={signin}>Send Verification Code</button>
				</div>
				<div style={{ display: show ? "block" : "none" }}>
					<input style={{width:"300px",height:"40px"}} type="text" placeholder={"Enter your OTP"}
						onChange={(e) => { setotp(e.target.value) }}></input>
					<br /><br />
					<button style={{
                         border: 'none',
                        //  color: '';
                         padding:' 15px 32px',
                         textAlign: 'center',
                         textDecoration: 'none',
                         display: 'inlineBlock',
                         fontSize: '13px',
                         backgroundColor:"#fac904"
                    }}  onClick={ValidateOtp}>Verify</button>
				</div>
			</center>
		</div>
        <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <a onClick={() => history.push('/')}>Back to Login</a>
        </div>
        </MainLayoutWrapper>
        </Container>
	);
}

export default PhoneLogin;
